/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Luci_Shopping_Api_Responses_ResponseCartItemV91 = {
  productId?: number;
  productGroupId?: number;
  quantity?: number;
  amount?: number;
  claimCode?: string;
  streamId?: number;
  additionalQuantityAvailable?: number;
  productName?: string;
  productSalePrice?: number;
  productThumbnailImageUrl?: string;
  productBundleId?: number;
  cartBundleItemId?: number;
  inventoryItemType?: Luci_Shopping_Api_Responses_ResponseCartItemV91.inventoryItemType;
  children?: Array<Luci_Shopping_Api_Responses_ResponseCartItemV91>;
};
export namespace Luci_Shopping_Api_Responses_ResponseCartItemV91 {
  export enum inventoryItemType {
    PRODUCT_GROUP = 'ProductGroup',
    PRODUCT_BUNDLE = 'ProductBundle',
  }
}

